// const AsyncStorage = {
//   setItem(...args) {
//     return Promise.resolve(localStorage.setItem(...args))
//   },
//   getItem(...args) {
//     return Promise.resolve(localStorage.getItem(...args))
//   },
//   clear() {
//     /*to clear the local storage -akshay 23april*/
//     return Promise.resolve(localStorage.clear())
//   },
//   removeItem(...args) {
//     return Promise.resolve(localStorage.removeItem(...args))
//   },a
//   multiGet(...args) {
//     return Promise.resolve(localStorage.multiGet(...args))
//   },
// }
// export default AsyncStorage

// const AsyncStorage = {
//   setItem(...args) {
//     return Promise.resolve(sessionStorage.setItem(...args))
//   },
//   getItem(...args) {
//     return Promise.resolve(sessionStorage.getItem(...args))
//   },
//   clear() {
//     /*to clear the session storage -akshay 23april*/
//     return Promise.resolve(sessionStorage.clear())
//   },
//   removeItem(...args) {
//     return Promise.resolve(sessionStorage.removeItem(...args))
//   },
//   multiGet(...args) {
//     // sessionStorage doesn't have multiGet natively, keep same behavior
//     return Promise.resolve(sessionStorage.multiGet?.(...args))
//   },
// }
// export default AsyncStorage



const AsyncStorage = {
  setItem(key, value, rememberMe = false) {
    if (rememberMe) {
      localStorage.setItem(key, value)
      sessionStorage.removeItem(key)           // keep single source of truth
    } else {
      sessionStorage.setItem(key, value)
      localStorage.removeItem(key)             // clear any stale "remember me" data
    }
    return Promise.resolve()
  },

  getItem(key) {
    // sessionStorage takes priority (active session), then fall back to localStorage
    const value =
      sessionStorage.getItem(key) ??
      localStorage.getItem(key)
    return Promise.resolve(value)
  },

  removeItem(key) {
    // always wipe from both — used on logout
    sessionStorage.removeItem(key)
    localStorage.removeItem(key)
    return Promise.resolve()
  },

  clear() {
    /*to clear both storages on logout -updated for rememberMe*/
    sessionStorage.clear()
    localStorage.clear()
    return Promise.resolve()
  },

  multiGet(keys) {
    const pairs = keys.map(key => {
      const value =
        sessionStorage.getItem(key) ??
        localStorage.getItem(key)
      return [key, value]
    })
    return Promise.resolve(pairs)
  },
}

export default AsyncStorage